<template>
    <section class="hero-component">
        <div class="main-page">
            <div class="h-100">
                <div class="row h-100">
                    <div class="col-lg-3 margin-tb-auto" data-aos="fade-right" id="main-image">
                        <div class="profile-image">
                            <img class="d-block hero-image" src="../assets/img/image.jpg" alt="First slide" />
                        </div>
                    </div>
                    <div id="aboutme" class="col-lg-9 margin-tb-auto" data-aos="fade-left">
                        <div class="ml-lg-5">
                            <h1 class="main-text">Rijal Permana</h1>
                            <h5 class="text-muted">FullStack Web Developer</h5>
                            <p class="text-justify">Hi.<br>
                            My Name is Rijal Permana. I graduated from Telkom University majoring in Computer Engineering. Currently I work as Web Developer at Neuronworks Indonesia.
                            Mainly I use <b>PHP</b> for Backend, <b>HTML5</b>, <b>CSS</b>, <b>Bootstrap</b>, <b>Vanilla javascript</b> and <b>jQuery</b> for Frontend. For database I use <b>PostgreSQL</b> but have some experiences using <b>Oracle Database</b> too.
                            I also doing personal projects using <b>React Js</b>, <b>Vue Js</b>, and <b>Node Js</b>. If you're interested to talk with me, you can contact me via icon below</p>
                            <div class="col-12 pl-lg-0 pt-4 social-links">
                                <span class="ml-2 ml-lg-0 mr-2 mr-lg-3">
                                    <a class="linkedin icon-rising" href="https://www.linkedin.com/in/rijalpermana" target="_blank" title="Linkedin">
                                        <font-awesome-icon class="icon-rising" :icon="['fab', 'linkedin']" size="3x"/>
                                    </a>
                                </span>
                                <span class="ml-2 ml-lg-0 mr-2 mr-lg-3">
                                    <a class="github icon-rising" href="https://github.com/rijalpermana00" target="_blank" title="Github">
                                        <font-awesome-icon class="icon-rising" :icon="['fab', 'github-square']" size="3x"/>
                                    </a>
                                </span>
                                <span class="ml-2 ml-lg-0 mr-2 mr-lg-3">
                                    <a class="email icon-rising" href="mailto:rijalpermana00@gmail.com" target="_blank" title="Email">
                                        <font-awesome-icon class="icon-rising" icon="envelope-square" size="3x"/>
                                    </a>
                                </span>
                                <span class="ml-2 ml-lg-0 mr-2 mr-lg-3">
                                    <a class="phone icon-rising" href="tel:+6282130943414" target="_blank" title="Phone">
                                        <font-awesome-icon class="icon-rising" icon="phone-square-alt" size="3x"/>
                                    </a>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import '../assets/css/Carousel.css'

    export default {
        name : 'HeroSection',
    }
</script>